import { render, staticRenderFns } from "./orderList2.vue?vue&type=template&id=33a651ea"
import script from "./orderList2.vue?vue&type=script&lang=js"
export * from "./orderList2.vue?vue&type=script&lang=js"
import style0 from "./orderList2.vue?vue&type=style&index=0&id=33a651ea&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a651ea')) {
      api.createRecord('33a651ea', component.options)
    } else {
      api.reload('33a651ea', component.options)
    }
    module.hot.accept("./orderList2.vue?vue&type=template&id=33a651ea", function () {
      api.rerender('33a651ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/orderList2.vue"
export default component.exports